import React from "react";
import Donut from "./Donut";


const ReportSection = () => {
  return (
    <div className="hidden sm:block rounded-2xl shadow-2xl bg-gradient-to-r from-[#F6F0FA] to-[#FFF]">
      <h3 className="text-xl font-bold text-slate-800 mb-2">Report</h3>
      <Donut solved={70} quiz={20} contest={10} />
    </div>
  );
}

export default ReportSection;
